// src/features/nameDescription/nameDescriptionSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    first_name: '',
  last_name:"",
  email:"",
  contact:"",
  password:"",
  rolesArrayData:[]


};

const addUserSlice = createSlice({
  name: 'addUserDetails',
  initialState,
  reducers: {
    setFirstName: (state, action) => {
      state.first_name = action.payload;
    },
    setLastName: (state, action) => {
        state.last_name = action.payload;
      },
      setEmail: (state, action) => {
        state.email = action.payload;
      },
      setContact: (state, action) => {
        state.contact = action.payload;
      },
      setPassword: (state, action) => {
        state.password = action.payload;
      },
      
  },
});

export const { setFirstName, setLastName, setEmail,setContact,setPassword } = addUserSlice.actions;

export default addUserSlice.reducer;
